import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import TableForm from "../../../../components/SubDepartmentTableForm";
import ModalManager from "../../../../components/modalManager";
import { setOpenModal } from "../../../../redux/Actions/UserAction";
import styles from "./subDepartment.module.css";
import Button from "@mui/material/Button"; // Assuming you're using Material UI for the button
import apiCall from "../../../API/apiService";
import apiEndpoints from "../../../API/apiEndpoints";
import DataTable from "../../../../components/subDepartmentData";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { toasty } from "../../../../Helper";
import { Pagination } from 'antd'; // Ensure this import is from 'antd'
import Typography from "@mui/material/Typography";
import CreateSubDepartment from "../../../assets/svgComponent/CreateSubDepartment.svg";

const SubDepartment = () => {
	const dispatch = useDispatch();
	const [rows, setRows] = React.useState([]);
	const [departmentList, setDepartmetList] = React.useState([]);
	const [noDataModalOpen, setNoDataModalOpen] = React.useState(false);
	const [organizations, setOrganizations] = React.useState([]);
	const [newItem, setNewItem] = React.useState({
		organisation_id: "",
		department_id: "",
		department_name: "",
		name: "",
		description: "",
		head: "",
		no_roles_open: "",
	});
	const [editingIndex, setEditingIndex] = React.useState(null);
	const [page, setPage] = React.useState(1);
	const [rowsPerPage, setRowsPerPage] = React.useState(15);
	const [totalPages, setTotalPages] = React.useState(1);
	const [totalItems, setTotalItems] = React.useState(0);
	const [filteredDepartmentList, setFilteredDepartmentList] = React.useState([]);

	useEffect(() => {
		fetchData(1); // Initial fetch with page 1
	}, []); // Only fetch subdepartment data on initial load

	const fetchData = async (currentPage) => {
		try {
			const response = await apiCall(
				"get", 
				`${apiEndpoints.SUB_DEPARTMENT}?page=${currentPage}&page_size=${rowsPerPage}`
			);
			setRows(response.items);
			setTotalItems(response.total);
			setTotalPages(Math.ceil(response.total / rowsPerPage));
		} catch (error) {
			console.error("Error fetching sub-departments:", error);
			toasty("Failed to fetch sub-departments", "error");
		}
	};

	const postData = async (obj) => {
		try {
			const data = await apiCall("post", apiEndpoints.SUB_DEPARTMENT, obj);
			console.log(data);
			toasty("SubDepartment Created successfully");
			dispatch(setOpenModal({ modalVisible: false }));
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};

	const putData = async (obj) => {
		try {
			const data = await apiCall("put", apiEndpoints.SUB_DEPARTMENT, obj);
			toasty("SubDepartment Updated successfully");
			dispatch(setOpenModal({ modalVisible: false }));
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};

	const deleteData = async (id) => {
		try {
			const data = await apiCall(
				"delete",
				`${apiEndpoints.SUB_DEPARTMENT}/${id}`
			);
			toasty("SubDepartment Deleted successfully");
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};

	const handleInputChange = (e) => {
		const { name, value } = e.target;

		if (name === "organisation_id") {
			console.log("Organization changed to:", value);
			// When organization changes, reset department-related fields
			setNewItem(prevItem => ({
				...prevItem,
				[name]: value,
				department_id: "",
				department_name: "",
			}));

			// Fetch departments for the selected organization

			if (value) {
				console.log("Fetching departments for org ID:", value);
				fetchDepartmentsByOrganization(value);
			} else {
				setFilteredDepartmentList([]);
			}

		} else if (name === "department_id") {
			// When department ID is selected, find the department name
			const selectedDept = filteredDepartmentList.find(dept => dept.id === value);
			setNewItem(prevItem => ({
				...prevItem,
				department_id: value,
				department_name: selectedDept ? selectedDept.name : "",
			}));
		} else {
			// For all other fields, update normally
			setNewItem(prevItem => ({
				...prevItem,
				[name]: value,
			}));
		}
	};

	// Function to fetch departments based on organization ID using new API endpoint
	const fetchDepartmentsByOrganization = async (organisationId) => {
		try {
			const response = await apiCall("get", `${apiEndpoints.DEPARTMENT_SUMMARY}?organisation_id=${organisationId}`);
			console.log("Department response:", response);

			
			if (!response || !Array.isArray(response)) {
				console.error("Invalid department response format", response);
				setFilteredDepartmentList([]);
				return;
			}
			

			// Map the response to include necessary fields for dropdown
			const mappedDepartments = response.map(dept => ({
				id: dept.id,
				name: dept.name,

			}));

			console.log("Mapped Departments:", mappedDepartments);
			setFilteredDepartmentList(mappedDepartments);
		} catch (error) {
			console.error("Error fetching departments:", error);
			setFilteredDepartmentList([]);
		}
	};

	const handleAddRow = async () => {
		const raw = {
			organisation_id: newItem.organisation_id,
			department_id: newItem.department_id,
			name: newItem.name,
			description: newItem.description,
			head: newItem.head,
		};
		await postData(raw);
		await fetchData(1);
		setNewItem({
			organisation_id: "",
			department_id: "",
			department_name: "",
			name: "",
			description: "",
			head: "",
			no_roles_open: "",
		});
	};

	const handleEditRow = async (id) => {
		dispatch(setOpenModal({ modalVisible: true }));
		setEditingIndex(id);
		const itemToEdit = rows.find((row) => row.id === id);
		
		// Fetch organizations when editing
		await fetchOrganizations();
		
		setNewItem({
			...itemToEdit,
			organisation_name: '',
			department_name: '',
		});
		
		// Fetch departments for this organization
		if (itemToEdit.organisation_id) {
			await fetchDepartmentsByOrganization(itemToEdit.organisation_id);
			
			// Find department name
			const departmentResponse = await apiCall("get", `${apiEndpoints.DEPARTMENT_SUMMARY}?organisation_id=${itemToEdit.organisation_id}`);
			const departmentName = departmentResponse.find(dept => dept.id === itemToEdit.department_id)?.name || '';
			
			setNewItem(prev => ({
				...prev,
				department_name: departmentName
			}));
		}
	};
	
	const handleSaveRow = async () => {
		const raw = {
			organisation_id: newItem.organisation_id,
			department_id: newItem.department_id,
			id: newItem.id,
			name: newItem.name,
			description: newItem.description,
			head: newItem.head,
		};
		await putData(raw);
		await fetchData(1);
		setEditingIndex(null);
		setNewItem({
			organisation_id: "",
			department_id: "",
			department_name: "",
			name: "",
			description: "",
			head: "",
			no_roles_open: "",
		});
	};

	const handleDeleteRow = async (id) => {
		await deleteData(id);
		await fetchData(1);
	};

	const handleSelectChange = (e, index) => {
		console.log(e)
		const updatedRows = [...rows];
		updatedRows[index].status = e;
		setRows(updatedRows);
	};

	// Open the modal for creating a new sub-department and fetch organizations
	const handleOpenCreateModal = async () => {
		setNewItem({
			organisation_id: "",
			department_id: "",
			department_name: "",
			name: "",
			description: "",
			head: "",
			no_roles_open: "",
		});
		setEditingIndex(null);
		
		// Fetch organizations only when creating a new sub-department
		await fetchOrganizations();
		
		dispatch(setOpenModal({ modalVisible: true }));
	};
	
	const handleCloseNoDataModal = () => {
		setNoDataModalOpen(false);
	};

	const fetchOrganizations = async () => {
		try {
			const response = await apiCall("get", apiEndpoints.ORGANIZATION_SUMMARY);
			console.log("Organizations response:", response);
			setOrganizations(response || []);
		} catch (error) {
			console.error("Error fetching organizations:", error);
			setOrganizations([]);
		}
	};

	const handlePageChange = (newPage) => {
		setPage(newPage);
		fetchData(newPage); // Fetch data only for the new page
	};

	return (
		<div className={styles.container}>
			{/* Create Sub-Department Button */}
			<div className={styles.buttonContainer} style={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				marginBottom: '10px',
				font: 'inter' // Add some spacing below the button container
			}}>
				<span style={{ fontFamily: 'Inter' ,marginLeft:'20px' }}>List of Sub-Department</span>
				<img
					style={{
						cursor: 'pointer',
						width: '170px',
						height: '38px',
						padding: '2px 10px 2px 8px',
						gap: '6px',
						borderRadius: '6px',
					}}
					onClick={handleOpenCreateModal}
					src={CreateSubDepartment}
				/>
			</div>

			<ModalManager customWidth={window.innerWidth / 300}>
			{console.log("New Item:", filteredDepartmentList)}
				<TableForm
					item={newItem}
					isEditing={editingIndex !== null}
					departments={filteredDepartmentList}
					organizations={organizations || []}
					onChange={handleInputChange}
					onSave={editingIndex !== null ? handleSaveRow : handleAddRow}
					onClear={() => {
						dispatch(setOpenModal({ modalVisible: false })); setNewItem({
							organisation_id: "",
							department_id: "",
							department_name: "",
							name: "",
							description: "",
							head: "",
							no_roles_open: "",
						})
					}}
				/>
			</ModalManager>

			{/* DataTable for displaying sub-departments */}
			<DataTable
				rows={rows}
				handleSelectChange={handleSelectChange}
				handleEditRow={handleEditRow}
				handleDeleteRow={handleDeleteRow}
				page={page}
				totalItems={totalItems}
				onPageChange={handlePageChange}
			/>

			<Dialog open={noDataModalOpen} onClose={handleCloseNoDataModal}>
				<DialogTitle>No Data Available</DialogTitle>
				<DialogContent>
					<p>There is no data available for the selected filters.</p>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseNoDataModal} color="primary">
						Close
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default SubDepartment;
